/**
 * **Hotelrunner**
 *
 * @exports partnership_292
 * @category partnerships
 */
function factory({ window, document, thn }) {

  const partnership = {};
  const dataLayer = window.dataLayer;

  /**
       * @memberOf module:partnership_292
       */
  partnership.getId = function getId() {
    return '292';
  };

  /**
       * @memberOf module:partnership_292
       */
  partnership.check = function check() {
    const isHotelRunner = !!(window.location.hostname.match(/hotelrunner/) || window.location.pathname.match(/bv3/));
    return isHotelRunner;
  };

  /**
       * @memberOf module:partnership_292
       */
  partnership.getSiteId = function getSiteId() {
    const hotelId = dataLayer.find((el) => el[0] === 'property_code')?.[1] || window.location.hostname.split('.')[0];
    const result = {
      externalId: hotelId,
    };
    return result;

  };

  return partnership;
}

export { factory };
